module.exports = __webpack_public_path__ + "img/gallery-img-6.0e013bd0.jpg";